<template>
  <v-snackbar
    color="white"
    class="pa-2"
    v-model="show"
    :timeout="timeout"
    top
    multi-line
  >
    <v-layout row align-center>
      <v-flex md2 mr-2>
        <div>
          <img
            :src="require(`./../../assets/${icon}`)"
            width="45px"
            height="45px"
          />
        </div>
      </v-flex>
      <v-flex md9>
        <div class="subheading black--text font-weight-bold">{{ $t(header) }}</div>
        <div class="body-2 extraGrey--text">{{ $t(message) }}</div>
      </v-flex>
      <v-flex md1 align-self-baseline>
        <v-btn class="ma-0 pa-0" color="error" flat @click="show = false">
          <v-icon>cancel</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    message: {
      type: String,
      default: "",
    },
    header: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      proxyShow: false,
      timeout: 5000,
    };
  },
  computed: {
    show: {
      get() {
        return this.proxyShow;
      },
      set(val) {
        this.proxyShow = val;
        this.$emit("update:snackbar", val);
      },
    },
  },
  mounted() {
    this.proxyShow = this.visible;
  },
};
</script>

<style>
.v-snack .v-snack__wrapper .v-snack__content {
  padding: 8px;
}
</style>
